<template>
    <b-form-group
        :label="showLabel ? $t('networks') : null"
        label-for="networks"
    >
        <Select
            id="networks-edit-options"
            class="mb-2"
            :state="state"
            :selected="editOption"
            :options="options"
            :disabled="disabled"
            @changeValue="$emit('update:editOption', $event)"
        />
        <b-form-checkbox-group
            id="networks"
            :options="defaultNetworks"
            :value="value"
            :state="state"
            @change="$emit('update:value', $event)"
        >
            <b-form-invalid-feedback :state="state">
                <span>{{
                    $t('usersBulkEdit.messages.selectTheDesiredNetworks')
                }}</span>
            </b-form-invalid-feedback>
        </b-form-checkbox-group>
    </b-form-group>
</template>

<script>
import { Select } from '@/views/components/selects'
import defaultNetworks from '@/data/networks'
import options from '@/data/networks-update-options'

export default {
    name: 'Networks',
    components: { Select },
    props: ['value', 'disabled', 'state', 'showLabel', 'editOption'],
    data() {
        return {
            options,
            defaultNetworks,
            loading: true,
        }
    },
    mounted() {
        const defaultOption = this.options.find(option => option.isDefault)
        this.$emit('update:editOption', defaultOption)
    },
}
</script>
